export * from "./admin-portal-auth.guard";
export * from "./admin-portal-access.guard";



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/guard/admin-portal/index.ts